import { connect } from 'react-redux';
import {
    clearAll,
    getLeadsStats,
    groupStatsBy,
    setSelectedGraphKeys,
    setFormField,
} from '../../reduxStore/config/leadsstats';
import LeadsStatsWrapper from './LeadsStatsWrapper';
import mapProductSummaryToTable from '../../utils/tableAdapter/genericTableAdapter';
import mapStatsToLineChart from '../../utils/chartAdapter/lineChartAdapter';
import {
    mapSourceToDoughnutGraph,
    mapPageToDoughnutGraph,
    mapLeadOriginToDoughnutGraph,
    mapCustomerToDoughnutGraph,
} from '../../utils/chartAdapter/doughnutChartAdapter';

const mapStateToProps = (state, ownProps) => {
    const {
        groupBy,
        formState,
        stats,
        graphDataPoint,
        graphDate,
        selectedGraphKeys,
    } = state.leadsstats;

    const {
        user,
        preferedLanguage,
    } = state.user;

    const {
        totalLeadCount,
        totalLeadCountCustomer,
        sourceSummary,
        pageSummary,
        leadOriginSummary,
        productSummary,
    } = stats;

    const {
        translation,
    } = ownProps;

    const graphKeys = graphDataPoint ? Object.keys(graphDataPoint)
        .map((product, index) => (
            {
                id: index,
                text: translation.PRODUCT_KEYS[product] || product,
                isDefault: product === 'total',
            }
        ))
        : [];

    const preSelectedGraphKeys = selectedGraphKeys || graphKeys.filter(key => key.isDefault);

    return {
        graphData: graphDataPoint && graphDate ? mapStatsToLineChart(
            graphDataPoint,
            graphDate,
            groupBy,
            translation,
        ) : null,

        graphKeys,

        preSelectedGraphKeys,

        tableData: productSummary && totalLeadCount ? mapProductSummaryToTable(
            productSummary,
            totalLeadCount,
            translation,
        ) : null,

        totalCount: totalLeadCount,
        totalCountString: totalLeadCount ? totalLeadCount.toLocaleString('sv-se') : null,

        translation,
        groupBy,
        formState,
        userLocale: preferedLanguage,
        isAnalyzeUser: user ? user.isAnalyzeUser : null,

        sourceData: sourceSummary && totalLeadCount ? mapSourceToDoughnutGraph(
            sourceSummary,
            totalLeadCount,
            translation,
        ) : null,

        pageData: pageSummary && totalLeadCount ? mapPageToDoughnutGraph(
            pageSummary,
            totalLeadCount,
            translation,
        ) : null,

        customerData: totalLeadCountCustomer && totalLeadCount ? mapCustomerToDoughnutGraph(
            totalLeadCountCustomer,
            totalLeadCount,
            translation,
        ) : null,

        leadOriginData: leadOriginSummary ? mapLeadOriginToDoughnutGraph(
            leadOriginSummary,
            translation,
        ) : null,
    };
};

const mapDispatchToProps = dispatch => ({
    handleClear: () => {
        dispatch(clearAll());
    },
    handleSubmit: (formData) => {
        dispatch(getLeadsStats(formData));
    },
    handleGroupBy: (groupBy) => {
        dispatch(groupStatsBy(groupBy));
    },
    handleSelectGraphKeys: (selected) => {
        dispatch(setSelectedGraphKeys(selected));
    },
    handleUpdateFormField: (field) => {
        dispatch(setFormField(field));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(LeadsStatsWrapper);
